<template>
  <div class="notification informers">
    <template v-for="(item, key) in $store.state.user.notifications">
      <informer
        v-if="item.type === 'msg'"
        :i="key"
        :id="item.id"
        :msg="item.msg"
        @close="close(key, item.id)"
        :bg-color="$vuetify.theme.themes.light.primary"
      ></informer>
      <informer
        v-else-if="item.type === 'curator'"
        :i="key"
        :id="item.id"
        :msg="item.msg"
        :btns="[{label: $t('msg.chatWithCurator'), click: clickCurator}]"
        @close="close(key, item.id)"
        :bg-color="$vuetify.theme.themes.light.primary"
        icon="mdi-face-agent"
      ></informer>
      <informer
        v-else-if="item.type === 'custom'"
        :msg="item.msg"
        :btns="item.btns"
        @close="customClose(key)"
      ></informer>
    </template>
  </div>
</template>

<script>
import Informer from "@/components/ui/Informer";

export default {
  components: {Informer},
  methods: {
    clickCurator(i, notificationId) {
      if (this.isMobile) {
        this.$router.push({name: 'curator'});
      } else {
        this.$emit('open-chat');
      }
      this.close(i, notificationId);
    },
    close(i, notificationId) {
      this.$store.commit('closeNotification', i);

      this.$store.dispatch('closeNotification', {
        id: notificationId,
      })
    },
    customClose(i) {
      this.$store.commit('closeNotification', i);
    }
  }
}
</script>

<style lang="scss">
.notification {
  margin-left: -10px;
  margin-right: -10px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;

  .informer {
    margin: 10px 10px;
  }
}
</style>